<div class="ui-g ui-fluid clear-ui">
    <div class="ui-g-12">
        <h1 class="card__title--h1 color--white layout-page-title">{{pageTitle}} {{object.name}}</h1>
    </div>
    <div class="ui-g-12 ui-xl-6">
        <!-- Left Side -->
        <div class="card">
            <div class="ui-g form-group">
                <div class="ui-g-12">
                    <div class="p-float-label">
                        <input pInputText [(ngModel)]="object.name">
                        <label>Name</label>
                    </div>
                </div>
            </div>

            <div class="ui-g">
                <button type="button"  [disabled]="isDisabled" label="Save" pButton icon="ui-icon-save" (click)="save()"></button>
                <button type="button"  [disabled]="isDisabled" label="Save & Close" pButton icon="ui-icon-save" (click)="saveAndClose()"></button>
                <button type="button"  [disabled]="isDisabled" label="Cancel" pButton icon="ui-icon-cancel" (click)="cancel()"></button>
            </div>
        </div>
    </div>
</div>
